import { render } from "./training-dashboard.vue?vue&type=template&id=9d2f59f2&scoped=true"
import script from "./training-dashboard.vue?vue&type=script&lang=js"
export * from "./training-dashboard.vue?vue&type=script&lang=js"

import "./training-dashboard.vue?vue&type=style&index=0&id=9d2f59f2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2f59f2"]])

export default __exports__